import { Instance, flow, types } from 'mobx-state-tree';

import { getCgParent, removeCgParent, saveCgParent } from '@common/api/cgParents';
import { deleteMedia } from '@common/api/media';
// import Service from '@common/models/Services/Service';
import User from '@common/models/Users/User';

const CgParentUser = types.model('CgParentUser', {
	id: types.maybeNull(types.number),
	first_name: types.maybeNull(types.string),
	last_name: types.maybeNull(types.string),
	email: types.maybeNull(types.string),
});

const CgParentSchool = types.model('CgParentSchool', {
	id: types.maybeNull(types.number),
	name: types.maybeNull(types.string),
});

const CgParentClass = types.model('CgParentClass', {
	id: types.maybeNull(types.number),
	name: types.maybeNull(types.string),
	c_g_school_id: types.maybeNull(types.number),
	c_g_coordinator_id: types.maybeNull(types.number),
	code: types.maybeNull(types.string),
});

const CgParentConsent = types.model('CgParentConsent', {
	is_granted: types.maybeNull(types.boolean),
	granted_at: types.maybeNull(types.string),
	source: types.maybeNull(types.string),
});

const CgParentConsents = types.model('CgParentConsents', {
	personal_data: types.maybeNull(CgParentConsent),
	marketing: types.maybeNull(CgParentConsent),
});

const CgParentOnboarding = types.model('CgParentOnboarding', {
	is_completed: types.maybeNull(types.boolean),
	source: types.maybeNull(types.string),
	updated_at: types.maybeNull(types.string),
});

const CgParentStudentUser = types.model('CgParentStudentUser', {
	id: types.maybeNull(types.number),
	first_name: types.maybeNull(types.string),
	last_name: types.maybeNull(types.string),
	email: types.maybeNull(types.string),
});

const CgParentStudent = types.model('CgParentStudent', {
	id: types.maybeNull(types.number),
	user_id: types.maybeNull(types.number),
	user: types.maybeNull(CgParentStudentUser),
});

const CgParent = types
	.compose(
		User,
		types.model({
			user: types.maybeNull(CgParentUser),
			phone: types.maybeNull(types.string),
			cg_login_token: types.maybeNull(types.string),
			phone_verified_at: types.maybeNull(types.string),
			// services: types.optional(types.array(Service), []),
			cg_students_ids: types.optional(types.array(types.number), []),
			cg_students: types.optional(types.array(CgParentStudent), []),
			classes: types.optional(types.array(CgParentClass), []),
			schools: types.optional(types.array(CgParentSchool), []),
			coordinators: types.optional(types.array(types.frozen()), []),
			consents: types.maybeNull(CgParentConsents),
			onboarding: types.maybeNull(CgParentOnboarding),
		}),
	)
	.named('CgParent')
	.preProcessSnapshot((snapshot: any) => ({
		...snapshot,
		cg_students_ids: snapshot?.cg_students_ids || [],
		cg_students: snapshot?.cg_students || [],
		classes: snapshot?.classes || [],
		schools: snapshot?.schools || [],
		coordinators: snapshot?.coordinators || [],
	}))
	.actions(() => ({
		_fetch: getCgParent,
		_save: saveCgParent,
		_remove: removeCgParent,
	}))
	.actions((self) => ({
		deleteAvatar: flow(function* () {
			yield deleteMedia({ id: self.user_id as number, entity: 'users', media_collection: 'avatar' });
			yield self._fetch(self.id);
		}),
	}));

export default CgParent;

export interface ICgParentModel extends Instance<typeof CgParent> {}
